import React from "react";

const variants = {
  active: "text-emerald-700",
  inactive: "text-slate-600",
  archived: "text-amber-700",
  pending: "text-amber-700",
  approved: "text-sky-700",
  danger: "text-red-700",
};

function StatusBadge({ active, label, variant }) {
  const resolvedVariant =
    variant ?? (active === false ? "inactive" : active === true ? "active" : "inactive");
  const classes = variants[resolvedVariant] ?? variants.inactive;

  return (
    <span className={`inline-flex items-center gap-2 font-semibold ${classes}`}>
      <span className="h-3 w-3 rounded-full bg-current" />
      <span>{label ?? (active ? "Active" : "Inactive")}</span>
    </span>
  );
}

export default StatusBadge;
